<template>
  <div class="settings-filters">
    <div class="job-type-dropdown">
      <label class="control-label setting-sub-title">
        Job type
        <i
          v-tooltip
          class="hi hi-info-filled ml-5"
          :title="tooltip"
        />
      </label>
      <AppDropdown
        :label="jobTypeLabel"
        direction="left"
      >
        <template v-if="hasJobTypeOptions">
          <AppDropdownItem
            v-for="jobType in jobTypeOptions"
            :key="jobType.id"
            @click="setJobType(jobType.id)"
          >
            {{ jobType.name }}
          </AppDropdownItem>
        </template>
        <AppDropdownItem
          v-else
          disabled
        >
          No job types available
        </AppDropdownItem>
      </AppDropdown>
    </div>

    <div class="ml-sm-10 my-sm-0 my-10 mr-auto">
      <label class="control-label setting-sub-title">Sort by</label>
      <AppDropdown
        :label="sortLabel"
        direction="left"
      >
        <AppDropdownItem
          v-for="option in sortOptions"
          :key="option.key"
          @click="setSort(option.key)"
        >
          {{ option.label }}
        </AppDropdownItem>
      </AppDropdown>
    </div>

    <div>
      <AppButton
        class="mr-auto"
        type="outline-primary"
        @click.stop="toggleFilters"
      >
        Filters
      </AppButton>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { SETTINGS_INSIGHTS } from '~/app_constants';

export default {
  name: 'SettingsInsightsOptions',
  data: () => ({
    sortOptions: Object.freeze(SETTINGS_INSIGHTS.sortOptions),
    tooltip: "See and edit App/URL's classification ratings for all members or by job type",
    categoryPlaceholder: 'Select Category',
  }),
  computed: {
    ...mapState(['query', 'filters', 'jobTypes', 'categories', 'loadingItems', 'tools', 'loading']),
    hasTools() {
      return this.tools && this.tools.length;
    },
    sortLabel() {
      return this.filters.sortBy
        ? this.sortOptions.find((o) => o.key === this.filters.sortBy).label
        : this.sortOptions[0].label;
    },
    jobTypePlaceholder() {
      return this.hasJobTypeOptions ? 'All job types' : 'Select Job Type';
    },
    jobTypeLabel() {
      return this.filters.jobType
        ? this.jobTypes.find((o) => o.id === this.filters.jobType).name
        : this.jobTypePlaceholder;
    },
    jobTypeOptions() {
      return [{ id: 0, name: this.jobTypePlaceholder }, ...this.jobTypes];
    },
    hasJobTypeOptions() {
      return this.jobTypes?.length;
    },
  },
  methods: {
    ...mapActions(['setSort', 'setJobType', 'toggleSidebar']),
    toggleFilters(event) {
      this.toggleSidebar();
      event.target.parentElement.dispatchEvent(new Event('click', { bubbles: true }));
    },
  },
};
</script>
